import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "subscription-card" }
const _hoisted_2 = { class: "subscription-card-header" }
const _hoisted_3 = { class: "subscription-card-title" }
const _hoisted_4 = { class: "subscription-card-qty-chip" }
const _hoisted_5 = {
  class: "icon sm remove-cart-item-logo",
  width: "18",
  height: "18",
  style: {"fill":"var(--invert-neutral)"},
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.146 11.217a.5.5 0 1 0 .708.708l3.182-3.182 3.181 3.182a.5.5 0 1 0 .708-.708l-3.182-3.18 3.182-3.182a.5.5 0 0 0-.708-.708l-3.18 3.181-3.183-3.182a.5.5 0 0 0-.708.708l3.182 3.182-3.182 3.181z",
  "stroke-width": "0"
}, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "small text-muted"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" A guest cart line with no catalogue row behind it - its price could not be loaded,\n\t     or the product is no longer available. Priced lines are regular SubscriptionCards;\n\t     this shows the product code, the quantity and a remove control only. "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h6", _hoisted_3, _toDisplayString($props.product_id), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_4, _toDisplayString($props.qty), 1 /* TEXT */),
        _createElementVNode("div", {
          class: "del grey-btn",
          onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('remove')))
        }, [
          _createCommentVNode(" Same markup as SubscriptionCard's remove glyph minus id=\"icon-close\". That card\n\t\t\t\t     gets its fill from Frappe's #icon-close rule by reusing the sprite symbol's id;\n\t\t\t\t     here the same token is set directly, since .icon alone leaves the glyph\n\t\t\t\t     transparent and a second element with that id is not valid HTML. "),
          (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
        ])
      ]),
      ($props.note)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($props.note), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}